@if (allowanceEntity$ | async) {
  <form (change)="saveForm()" [formGroup]="formGroup">
    @if (kinderen.length > 0) {
      <div formArrayName="kinderen">
        @for (item of kinderen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Roepnaam' : ''"
                                              [required]=true
                                              class="custom-input-150"
                                              formControlName="voornaam"
                                              id="voornaam-{{i}}"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Geboortedatum' : ''"
                                              [required]=true
                                              class="custom-input-150"
                                              formControlName="geboortedatum"
                                              id="geboortedatum-{{i}}"
                                              placeholder="dd-mm-jjjj"
              >
              </snelstart-ui-date-form-control>
              <snelstart-ui-bsn-form-control [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                             [required]=true
                                             class="custom-input-150"
                                             formControlName="bsn"
                                             id="bsn-{{i}}"
              >
              </snelstart-ui-bsn-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Ingeschreven bij aanvrager' : ''"
                                                [options]="itemsInschrijvingAangever"
                                                [required]=true
                                                class="custom-input-250"
                                                formControlName="ouderOntvangtKinderbijslag"
                                                id="ouderOntvangtKinderbijslag-{{i}}"
              >
              </snelstart-ui-select-form-control>
              @if (!item.controls.ouderOntvangtKinderbijslag.value) {
                <snelstart-ui-select-form-control [disabledControl]="false"
                                                  [label]="i === 0 ? 'Co-ouderschap' : ''"
                                                  [options]="optionsJaNee"
                                                  class="custom-input-150"
                                                  formControlName="onderhoudBelangrijkeMate"
                                                  id="ouderOntvangtKinderbijslag-{{i}}"
                >
                </snelstart-ui-select-form-control>
              }
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDelete"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancelB"
                       type="link">Kind toevoegen
  </snelstart-ui-button>
}
